import styled from 'styled-components';

export default styled.div`
  padding: 20px ${(props) => props.theme.grid.gap};
  background-color: ${(props) => props.theme.gray1};
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    display: none;
  }
`;
